import { StanModal } from '@/components';

interface DeleteFlowModalProps {
    isOpen: boolean;
    flowName: string;
    onConfirm: () => void;
    onCancel: () => void;
    type?: 'flow' | 'broadcast';
}

export const DeleteFlowModal = ({ isOpen, flowName, onConfirm, onCancel, type = 'flow' }: DeleteFlowModalProps) => {
    const itemType = type === 'broadcast' ? 'Broadcast' : 'Flow';

    return (
        <StanModal
            id='delete-flow-modal'
            isOpen={isOpen}
            onClose={onCancel}
            title='Are you sure?'
            size='sm'
            primaryActionLabel={`Delete ${itemType}`}
            secondaryActionLabel='Cancel'
            primaryActionColor='destructive'
            secondaryActionColor='secondary'
            onPrimaryAction={onConfirm}
            onSecondaryAction={onCancel}
            hideCloseButton
        >
            <p className='text-dark text-caption-1-regular text-center'>
                Just confirming that you want to delete <span className='font-semibold'>&quot;{flowName}&quot;</span>.
                This action cannot be undone.
            </p>
        </StanModal>
    );
};
